import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Notification } from 'src/app/model/notification';
import { AppState } from 'src/app/store/app.reducer';
import { selectNotificationList } from 'src/app/store/notifications/notifications.selector';

import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import { AppMainComponent } from 'src/app/menu/app.main.component';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-notificationlist',
  templateUrl: './notification-list.component.html',
  styles: [
		`
      .fadeInDown {
        max-height: 700px;
        overflow: auto;
      }
		`
  ]
})
export class NotificationListComponent implements OnInit, OnDestroy {
  notificationListSel$: Observable<Notification[]>;
  notificationListSub: Subscription | undefined;
  notificationList: Notification[] = [];

  constructor(
    public appMain: AppMainComponent,
    private router: Router,
    private store: Store<AppState>,
  ) {
    this.notificationListSel$ = this.store.select(selectNotificationList);
  }

  ngOnInit(): void {
    this.notificationListSub = this.notificationListSel$.subscribe(
      (notifications: Notification[]) =>
        this.notificationsCallback(notifications)
    );
  }

  ngOnDestroy(): void {
    if (this.notificationListSub) {
      this.notificationListSub?.unsubscribe();
    }
  }

  notificationsCallback(notifications: Notification[]): void {
    this.notificationList = notifications;
  }

  clearMessages() {
    this.store.dispatch(NotificationsActions.clearNotifications());
  }

  clickNotification(index: number): void {
    if (index < this.notificationList.length) {
      const route = this.notificationList[index].route;
      if (route) {
        this.router.navigate([route]);
      }
      this.store.dispatch(NotificationsActions.removeNotification({ index }));
    }
  }
}
